import UpdateUser from "./update-user.page";

export default UpdateUser;
